
// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { ERROR_INVALID_PASSWORD, ERROR_USER_BLOCKED } = require('constants/contactCenter/errorTypes');
const { TOKEN_CREDENTIAL } = require('constants/session');

// @ utilities
const usd = require('utilities/usd');
const Storage = require('utilities/storage');

//@helpers
const { raiseToN1ByPositions } = require('utilities/contactCenter/authenticationActionsHelper');

const setPasswordError = error => ({
    type: actionTypes.LOG_AS_CLIENT_PASSWORD_ERROR,
    payload: {
        error
    }
});

const clientLoginInProgress = () => ({
    type: actionTypes.LOG_AS_CLIENT_REQUEST
});

const clientLoginFailure = (error) => ({
    type: actionTypes.LOG_AS_CLIENT_FAILURE,
    payload: {
        error
    }
});

const clientLoginSuccess = (data) => ({
    type: actionTypes.LOG_AS_CLIENT_SUCCESS,
    payload: {
        info:  data
    }
});

const clientLoginReset = () => ({
    type: actionTypes.LOG_AS_CLIENT_PASSWORD_RESET
});

const validateClientPin = (positions, values) => (dispatch, getState) => {
    const isAlreadyFetching = getState().loginAsClient.get('isFetching');

    if (!isAlreadyFetching) {
        const interactionId = usd.getInteractionId();
        const tokenCredential = Storage.cookies.get(TOKEN_CREDENTIAL);

        dispatch(clientLoginInProgress());

        return raiseToN1ByPositions(interactionId, tokenCredential, positions, values, dispatch, getState)
        .then(response => {
            usd.setSecurityLevel(response.level);
            dispatch(clientLoginSuccess(response));
        })
        .catch(error => {
            switch(error.errorType) {
                case ERROR_INVALID_PASSWORD:
                case ERROR_USER_BLOCKED:
                    dispatch(setPasswordError(error));
                    break;
                default:
                    dispatch(clientLoginFailure(error));
            }
        });
    }
};

module.exports = {
    validateClientPin,
    clientLoginReset
};
